"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _AdaptiveCardAttachment = _interopRequireDefault(require("../../Attachment/AdaptiveCardAttachment"));

var _AnimationCardAttachment = _interopRequireDefault(require("../../Attachment/AnimationCardAttachment"));

var _AudioCardAttachment = _interopRequireDefault(require("../../Attachment/AudioCardAttachment"));

var _HeroCardAttachment = _interopRequireDefault(require("../../Attachment/HeroCardAttachment"));

var _OAuthCardAttachment = _interopRequireDefault(require("../../Attachment/OAuthCardAttachment"));

var _ReceiptCardAttachment = _interopRequireDefault(require("../../Attachment/ReceiptCardAttachment"));

var _SignInCardAttachment = _interopRequireDefault(require("../../Attachment/SignInCardAttachment"));

var _ThumbnailCardAttachment = _interopRequireDefault(require("../../Attachment/ThumbnailCardAttachment"));

var _VideoCardAttachment = _interopRequireDefault(require("../../Attachment/VideoCardAttachment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // TODO: [P4] Rename this file or the whole middleware, it looks either too simple or too comprehensive now


function _default(props) {
  return function () {
    return function (next) {
      return function (_ref) {
        var activity = _ref.activity,
            attachment = _ref.attachment;
        return attachment.contentType === 'application/vnd.microsoft.card.hero' ? _react.default.createElement(_HeroCardAttachment.default, _extends({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.adaptive' ? _react.default.createElement(_AdaptiveCardAttachment.default, _extends({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.animation' ? _react.default.createElement(_AnimationCardAttachment.default, _extends({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.audio' ? _react.default.createElement(_AudioCardAttachment.default, _extends({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.oauth' ? _react.default.createElement(_OAuthCardAttachment.default, _extends({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.receipt' ? _react.default.createElement(_ReceiptCardAttachment.default, _extends({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.signin' ? _react.default.createElement(_SignInCardAttachment.default, _extends({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.thumbnail' ? _react.default.createElement(_ThumbnailCardAttachment.default, _extends({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.video' ? _react.default.createElement(_VideoCardAttachment.default, _extends({}, props, {
          activity: activity,
          attachment: attachment
        })) : next({
          activity: activity,
          attachment: attachment
        });
      };
    };
  };
}